<template>
  <div v-if="currentRepo">
    <OverviewR v-if="rRepo" />
    <OverviewBioc v-if="biocRepo" />
    <OverviewPython v-else-if="pythonRepo" />
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import OverviewR from './r/OverviewR'
import OverviewPython from './python/OverviewPython'
import OverviewBioc from './bioconductor/OverviewBioc'
import { REPO_TYPE_R, REPO_TYPE_PYTHON, REPO_TYPE_BIOCONDUCTOR } from '../constants/repo-types'

export default {
  name: 'Overview',
  components: {
    OverviewR,
    OverviewBioc,
    OverviewPython,
  },
  computed: {
    ...mapGetters([
      'currentRepo',
    ]),
    ...mapState({
      currentRepoType: state => state.repos.currentRepoType,
    }),
    rRepo: function () {
      return this.currentRepoType === REPO_TYPE_R
    },
    biocRepo: function () {
      return this.currentRepoType === REPO_TYPE_BIOCONDUCTOR
    },
    pythonRepo: function () {
      return this.currentRepoType === REPO_TYPE_PYTHON
    },
  },
}

</script>
